<div id="layout" class="f_col">
    <app-view-title fromRoute="welcome1">{{'welcome.title_2.DYN.' + api.env.type | translate : {appName: api.env.name} }}</app-view-title>
    <div class="scroll_wrapper resp_wrapper">
        <div class="resp_scroll-wrapper_l resp_c-50">
            <app-view-deco-image class="mt_20 mb_20" imageUrl="assets-projects/images/image_question.svg"></app-view-deco-image>
            <div class="welcome-text">
                <p>{{'welcome.text_2.DYN.'+api.env.type | translate : {appName: api.env.name} }}</p>
                <p>{{'welcome.text_2.1.DYN.'+api.env.type | translate}}</p>
            </div>

          <div class="resp_minSize_l mb_20 mt_20 flex gap_10">
            <app-button size="xsm" color="transparent" border="true" class="fullWidth" (btnClicked)="nav.to('welcome-hello')">
              {{'global.previous' | translate}}
            </app-button>
            <app-button size="xsm" class="fullWidth" (btnClicked)="nav.to(api.userRole.isCustomer ? 'welcome-thanks' : 'welcome-employee')">
              {{'global.next' | translate}}
            </app-button>
          </div>
        </div>
    </div>

  <div class="f_align_end mb_20 gap_10 resp_maxSize_l">
    <app-back-btn icon="house" [navTo]="{route: 'dashboard'}"></app-back-btn>
    <app-back-btn (btnClicked)="nav.to('welcome-hello')"></app-back-btn>
    <app-button class="fullWidth" (btnClicked)="nav.to(api.userRole.isCustomer ? 'welcome-thanks' : 'welcome-employee')">
      {{'global.next' | translate}}
    </app-button>
  </div>
</div>
